import { createReducer } from './utilities';
import { ADD_NOTIFICATION, RESET_NOTIFICATIONS } from '../actions/notifications';

const initialNotificationsState = [];

function addNotification(state, action) {
    const { notification } = action;
    return [
        notification,
        ...state,
    ]
}

function resetNotifications() {
    return initialNotificationsState;
}

export default createReducer(initialNotificationsState, {
    [ADD_NOTIFICATION]: addNotification,
    [RESET_NOTIFICATIONS]: resetNotifications
});



// WEBPACK FOOTER //
// ./src/reducers/notifications.js